var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _circle2, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFrame2120412722 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8109,
    cy: 15.4886,
    r: 15.4886,
    fill: "#D83737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2256 7.6134C11.2531 7.6134 8.83735 10.0291 8.83735 13.0016V15.5969C8.83735 16.1447 8.60386 16.9799 8.32547 17.4469L7.29273 19.1621C6.65512 20.2218 7.09516 21.3983 8.26261 21.7934C12.1331 23.0866 16.309 23.0866 20.1795 21.7934C21.2662 21.4342 21.7421 20.15 21.1494 19.1621L20.1167 17.4469C19.8473 16.9799 19.6138 16.1447 19.6138 15.5969V13.0016C19.6138 10.0381 17.1891 7.6134 14.2256 7.6134Z",
    stroke: "white",
    strokeWidth: 0.94,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8862 7.87371C15.6078 7.79289 15.3204 7.73003 15.0241 7.69411C14.162 7.58634 13.3358 7.6492 12.5635 7.87371C12.8239 7.20917 13.4705 6.74219 14.2248 6.74219C14.9792 6.74219 15.6258 7.20917 15.8862 7.87371Z",
    stroke: "white",
    strokeWidth: 0.94,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.77 22.3059C16.77 23.7877 15.5577 25 14.0759 25C13.3396 25 12.657 24.6947 12.1721 24.2097C11.6872 23.7248 11.3818 23.0423 11.3818 22.3059",
    stroke: "white",
    strokeWidth: 0.94,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C13.5 20.5 14.5 20.5 16 20",
    stroke: "white",
    strokeWidth: 0.94,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.85,
    y: 4.85,
    width: 12.3,
    height: 12.3,
    rx: 6.15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.85,
    y: 4.85,
    width: 12.3,
    height: 12.3,
    rx: 6.15,
    stroke: "#D83737",
    strokeWidth: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11,
    r: 5,
    fill: "#D83737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2106 10.1035C20.0424 10.1035 19.8888 10.2353 19.8962 10.4033C19.9042 10.5832 19.7607 10.7315 19.5825 10.7315H18.9544C18.781 10.7315 18.6404 10.5909 18.6404 10.4175C18.6404 10.2441 18.4998 10.1035 18.3263 10.1035H17.6983C17.4497 10.1035 17.2107 10.1447 16.9878 10.2208C16.1224 10.5162 15.5 11.3363 15.5 12.3017C15.5 13.5158 16.4842 14.5 17.6983 14.5C17.7721 14.5 19.315 14.5101 19.7708 12.952C19.934 12.3942 20.4105 11.9877 20.9916 11.9877H22.2832C22.6301 11.9877 22.9113 11.7065 22.9113 11.3596V10.7315C22.9113 10.3847 22.6301 10.1035 22.2832 10.1035H20.2106Z",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6976 13.1526C17.2281 13.1526 16.8467 12.7712 16.8467 12.3017C16.8467 11.8322 17.2281 11.4508 17.6976 11.4508C18.1671 11.4508 18.5486 11.8322 18.5486 12.3017C18.5486 12.7712 18.1671 13.1526 17.6976 13.1526Z",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2061 7.59116V8.21924",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.873 8.40318L18.3172 8.84729",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5379 8.40318L20.0938 8.84729",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFrame2120412722, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Frame 2120412722.1b30738c.svg";
export { ForwardRef as ReactComponent };